export const position_select = [
  {
    value: "Professor",
    label: "Professor",
  },
  {
    value: "Lecturer",
    label: "Lecturer",
  },
  {
    value: "Instructor",
    label: "Instructor",
  },
  {
    value: "Director",
    label: "Director",
  },
  {
    value: "Assistant",
    label: "Assistant",
  },
];

export const seniority_select = [
  {
    value: "0",
    label: "1-10",
  },
  {
    value: "1",
    label: "10-20",
  },
  {
    value: "2",
    label: "20-30",
  },
  {
    value: "3",
    label: "30-40",
  },
  {
    value: "4",
    label: "40-50",
  },
  {
    value: "5",
    label: "50+",
  },
];

const classification_select_hierarchy = [
  {
    label: "Carnegie Classifications",
    options: [
      {
        label: "Basic 2021",
        options: [
          {
            label: "Not classified, not in classification universe",
            value:
              "Carnegie Classifications/Basic 2021/Not classified, not in classification universe",
          },
          {
            label: "Associate's Colleges",
            options: [
              {
                label: "High Transfer",
                options: [
                  {
                    label: "High Traditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Transfer-High Traditional",
                  },
                  {
                    label: "Mixed Traditional/Nontraditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Transfer-Mixed Traditional/Nontraditional",
                  },
                  {
                    label: "High Nontraditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Transfer-High Nontraditional",
                  },
                ],
              },
              {
                label: "Mixed Transfer",
                options: [
                  {
                    label: "Career & Technical",
                    options: [
                      {
                        label: "High Traditional",
                        value:
                          "Carnegie Classifications/Basic 2021/Associate's Colleges/Mixed Transfer/Career & Technical-High Traditional",
                      },
                      {
                        label: "Mixed Traditional/Nontraditional",
                        value:
                          "Carnegie Classifications/Basic 2021/Associate's Colleges/Mixed Transfer/Career & Technical-Mixed Traditional/Nontraditional",
                      },
                      {
                        label: "High Nontraditional",
                        value:
                          "Carnegie Classifications/Basic 2021/Associate's Colleges/Mixed Transfer/Career & Technical-High Nontraditional",
                      },
                    ],
                  },
                ],
              },
              {
                label: "High Career & Technical",
                options: [
                  {
                    label: "High Traditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Career & Technical-High Traditional",
                  },
                  {
                    label: "Mixed Traditional/Nontraditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Career & Technical-Mixed Traditional/Nontraditional",
                  },
                  {
                    label: "High Nontraditional",
                    value:
                      "Carnegie Classifications/Basic 2021/Associate's Colleges/High Career & Technical-High Nontraditional",
                  },
                ],
              },
            ],
          },
          {
            label: "Special Focus Two-Year",
            options: [
              {
                label: "Health Professions",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Two-Year/Health Professions",
              },
              {
                label: "Technical Professions",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Two-Year/Technical Professions",
              },
              {
                label: "Arts & Design",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Two-Year/Arts & Design",
              },
              {
                label: "Other Fields",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Two-Year/Other Fields",
              },
            ],
          },
          {
            label: "Baccalaureate",
            options: [
              {
                label: "Associate's Colleges",
                options: [
                  {
                    label: "Associate's Dominant",
                    value:
                      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges/Associate's Dominant",
                  },
                  {
                    label: "Mixed Baccalaureate/Associate's",
                    value:
                      "Carnegie Classifications/Basic 2021/Baccalaureate/Associate's Colleges/Mixed Baccalaureate/Associate's",
                  },
                ],
              },
            ],
          },
          {
            label: "Doctoral Universities",
            options: [
              {
                label: "Very High Research Activity",
                value:
                  "Carnegie Classifications/Basic 2021/Doctoral Universities/Very High Research Activity",
              },
              {
                label: "High Research Activity",
                value:
                  "Carnegie Classifications/Basic 2021/Doctoral Universities/High Research Activity",
              },
            ],
          },
          {
            label: "Doctoral/Professional Universities",
            value:
              "Carnegie Classifications/Basic 2021/Doctoral/Professional Universities",
          },
          {
            label: "Master's Colleges & Universities",
            options: [
              {
                label: "Larger Programs",
                value:
                  "Carnegie Classifications/Basic 2021/Master's Colleges & Universities/Larger Programs",
              },
              {
                label: "Medium Programs",
                value:
                  "Carnegie Classifications/Basic 2021/Master's Colleges & Universities/Medium Programs",
              },
              {
                label: "Small Programs",
                value:
                  "Carnegie Classifications/Basic 2021/Master's Colleges & Universities/Small Programs",
              },
            ],
          },
          {
            label: "Baccalaureate Colleges",
            options: [
              {
                label: "Arts & Sciences Focus",
                value:
                  "Carnegie Classifications/Basic 2021/Baccalaureate Colleges/Arts & Sciences Focus",
              },
              {
                label: "Diverse Fields",
                value:
                  "Carnegie Classifications/Basic 2021/Baccalaureate Colleges/Diverse Fields",
              },
            ],
          },
          {
            label: "Special Focus Four-Year",
            options: [
              {
                label: "Faith-Related Institutions",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Faith-Related Institutions",
              },
              {
                label: "Medical Schools & Centers",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Medical Schools & Centers",
              },
              {
                label: "Other Health Professions Schools",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Other Health Professions Schools",
              },
              {
                label: "Research Institution",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Research Institution",
              },
              {
                label: "Engineering and Other Technology-Related Schools",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Engineering and Other Technology-Related Schools",
              },
              {
                label: "Business & Management Schools",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Business & Management Schools",
              },
              {
                label: "Arts, Music & Design Schools",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Arts, Music & Design Schools",
              },
              {
                label: "Law Schools",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Law Schools",
              },
              {
                label: "Other Special Focus Institutions",
                value:
                  "Carnegie Classifications/Basic 2021/Special Focus Four-Year/Other Special Focus Institutions",
              },
            ],
          },
          {
            label: "Tribal Colleges and Universities",
            value:
              "Carnegie Classifications/Basic 2021/Tribal Colleges and Universities",
          },
        ],
      },
      {
        label: "Population Served",
        options: [
          {
            label: "Women's Colleges",
            value:
              "Carnegie Classifications/Population Served/Women's Colleges",
          },
          {
            label: "Historically Black Colleges and Universities",
            value:
              "Carnegie Classifications/Population Served/Historically Black Colleges and Universities",
          },
          {
            label: "Hispanic Serving Institutions",
            value:
              "Carnegie Classifications/Population Served/Hispanic Serving Institutions",
          },
          {
            label: "Tribal Colleges and Universities",
            value:
              "Carnegie Classifications/Population Served/Tribal Colleges and Universities",
          },
          {
            label: "Minority Serving Institutions",
            value:
              "Carnegie Classifications/Population Served/Minority Serving Institutions",
          },
        ],
      },
    ],
  },
];

const generateOptions = (data, level = 0) => {
  const options = [];

  data.forEach((item) => {
    if (item.options) {
      options.push({
        label: item.label,
        rawLabel: item.label,
        value: `__LABEL__${item.label}`,
        disabled: true,
        isHeader: true,
        level: level,
      });
      options.push(...generateOptions(item.options, level + 1));
    } else {
      options.push({
        label: item.label,
        rawLabel: item.label,
        value: item.value,
        isHeader: false,
        level: level,
      });
    }
  });

  return options;
};

export const classification_select = generateOptions(
  classification_select_hierarchy
);

export const state_select = [
  {
    value: "AL",
    label: "Alabama",
  },
  {
    value: "AK",
    label: "Alaska",
  },
  {
    value: "AZ",
    label: "Arizona",
  },
  {
    value: "AR",
    label: "Arkansas",
  },
  {
    value: "CA",
    label: "California",
  },
  {
    value: "CO",
    label: "Colorado",
  },
  {
    value: "CT",
    label: "Connecticut",
  },
  {
    value: "DE",
    label: "Delaware",
  },
  {
    value: "FL",
    label: "Florida",
  },
  {
    value: "GA",
    label: "Georgia",
  },
  {
    value: "HI",
    label: "Hawaii",
  },
  {
    value: "ID",
    label: "Idaho",
  },
  {
    value: "IL",
    label: "Illinois",
  },
  {
    value: "IN",
    label: "Indiana",
  },
  {
    value: "IA",
    label: "Iowa",
  },
  {
    value: "KS",
    label: "Kansas",
  },
  {
    value: "KY",
    label: "Kentucky",
  },
  {
    value: "LA",
    label: "Louisiana",
  },
  {
    value: "ME",
    label: "Maine",
  },
  {
    value: "MD",
    label: "Maryland",
  },
  {
    value: "MA",
    label: "Massachusetts",
  },
  {
    value: "MI",
    label: "Michigan",
  },
  {
    value: "MN",
    label: "Minnesota",
  },
  {
    value: "MS",
    label: "Mississippi",
  },
  {
    value: "MO",
    label: "Missouri",
  },
  {
    value: "MT",
    label: "Montana",
  },
  {
    value: "NE",
    label: "Nebraska",
  },
  {
    value: "NV",
    label: "Nevada",
  },
  {
    value: "NH",
    label: "New Hampshire",
  },
  {
    value: "NJ",
    label: "New Jersey",
  },
  {
    value: "NM",
    label: "New Mexico",
  },
  {
    value: "NY",
    label: "New York",
  },
  {
    value: "NC",
    label: "North Carolina",
  },
  {
    value: "ND",
    label: "North Dakota",
  },
  {
    value: "OH",
    label: "Ohio",
  },
  {
    value: "OK",
    label: "Oklahoma",
  },
  {
    value: "OR",
    label: "Oregon",
  },
  {
    value: "PA",
    label: "Pennsylvania",
  },
  {
    value: "RI",
    label: "Rhode Island",
  },
  {
    value: "SC",
    label: "South Carolina",
  },
  {
    value: "SD",
    label: "South Dakota",
  },
  {
    value: "TN",
    label: "Tennessee",
  },
  {
    value: "TX",
    label: "Texas",
  },
  {
    value: "UT",
    label: "Utah",
  },
  {
    value: "VT",
    label: "Vermont",
  },
  {
    value: "VA",
    label: "Virginia",
  },
  {
    value: "WA",
    label: "Washington",
  },
  {
    value: "WV",
    label: "West Virginia",
  },
  {
    value: "WI",
    label: "Wisconsin",
  },
  {
    value: "WY",
    label: "Wyoming",
  },
];
export const basic2021_select = [
  { value: 1, label: "Associate's Colleges: High Transfer-High Traditional" },
  {
    value: 2,
    label:
      "Associate's Colleges: High Transfer-Mixed Traditional/Nontraditional",
  },
  {
    value: 3,
    label: "Associate's Colleges: High Transfer-High Nontraditional",
  },
  {
    value: 4,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-High Traditional",
  },
  {
    value: 5,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value: 6,
    label:
      "Associate's Colleges: Mixed Transfer/Career & Technical-High Nontraditional",
  },
  {
    value: 7,
    label: "Associate's Colleges: High Career & Technical-High Traditional",
  },
  {
    value: 8,
    label:
      "Associate's Colleges: High Career & Technical-Mixed Traditional/Nontraditional",
  },
  {
    value: 9,
    label: "Associate's Colleges: High Career & Technical-High Nontraditional",
  },
  { value: 10, label: "Special Focus Two-Year: Health Professions" },
  { value: 11, label: "Special Focus Two-Year: Technical Professions" },
  { value: 12, label: "Special Focus Two-Year: Arts & Design" },
  { value: 13, label: "Special Focus Two-Year: Other Fields" },
  {
    value: 14,
    label: "Baccalaureate/Associate's Colleges: Associate's Dominant",
  },
  { value: 15, label: "Doctoral Universities: Very High Research Activity" },
  { value: 16, label: "Doctoral Universities: High Research Activity" },
  { value: 17, label: "Doctoral/Professional Universities" },
  { value: 18, label: "Master's Colleges & Universities: Larger Programs" },
  { value: 19, label: "Master's Colleges & Universities: Medium Programs" },
  { value: 20, label: "Master's Colleges & Universities: Small Programs" },
  { value: 21, label: "Baccalaureate Colleges: Arts & Sciences Focus" },
  { value: 22, label: "Baccalaureate Colleges: Diverse Fields" },
  {
    value: 23,
    label:
      "Baccalaureate/Associate's Colleges: Mixed Baccalaureate/Associate's",
  },
  { value: 24, label: "Special Focus Four-Year: Faith-Related Institutions" },
  { value: 25, label: "Special Focus Four-Year: Medical Schools & Centers" },
  {
    value: 26,
    label: "Special Focus Four-Year: Other Health Professions Schools",
  },
  { value: 27, label: "Special Focus Four-Year: Research Institution" },
  {
    value: 28,
    label:
      "Special Focus Four-Year: Engineering and Other Technology-Related Schools",
  },
  {
    value: 29,
    label: "Special Focus Four-Year: Business & Management Schools",
  },
  { value: 30, label: "Special Focus Four-Year: Arts, Music & Design Schools" },
  { value: 31, label: "Special Focus Four-Year: Law Schools" },
  {
    value: 32,
    label: "Special Focus Four-Year: Other Special Focus Institutions",
  },
  { value: 33, label: "Tribal Colleges and Universities" },
  { value: -2, label: "Not classified, not in classification universe" },
];
export const time_range_select = [
  {
    value: "last_5_years",
    label: "Last 5 years",
  },
  {
    value: "last_10_years",
    label: "Last 10 years",
  },
];

export const sort_by = [
  {
    value: 1,
    label: "Most Recent",
  },
  {
    value: 2,
    label: "Most Cited",
  },
];
export const concept_publication_type = [
  {
    label: "Notable Papers",
    value: 1,
  },
  { label: "Survey Papers", value: 2 },
];
export const concept_academic_type = [
  {
    label: "Top Scholars",
    value: 1,
  },
  { label: "Top Institutions", value: 2 },
];

export const level_select = [
  { label: "Level 1", value: 1 },
  { label: "Level 2", value: 2 },
  { label: "Level 3", value: 3 },
  { label: "Level 4", value: 4 },
];

export const school_type_select = [
  { label: "National Universities", value: "national-universities" },
  {
    label: "National Liberal Arts Colleges",
    value: "national-liberal-arts-colleges",
  },
  {
    label: "Regional Universities North",
    value: "regional-universities-north",
  },
  {
    label: "Regional Universities South",
    value: "regional-universities-south",
  },
  { label: "Regional Universities West", value: "regional-universities-west" },
  {
    label: "Regional Universities Midwest",
    value: "regional-universities-midwest",
  },
  { label: "Regional Colleges North", value: "regional-colleges-north" },
  { label: "Regional Colleges South", value: "regional-colleges-south" },
  { label: "Regional Colleges West", value: "regional-colleges-west" },
  { label: "Regional Colleges Midwest", value: "regional-colleges-midwest" },
  { label: "Special Focus Universities", value: "special-focus-universities" },
  { label: "Health", value: "health" },
];
